<template>
    <div  class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="$parentInfo.dialog_InvoiceDetail.printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
                <div style="position: absolute;right: 140px;top: -8px;z-index: 1;">
                    <canvas id="msg"></canvas>
                </div>
            </div>
            <div :style="{'height':$parentInfo.dialog_InvoiceDetail.maxHeight-45+'px'}" id="print">
                <div id="printArea"
                     class="printableArea"
                     :class="{'ph':!$parentInfo.dialog_InvoiceDetail.printOn,'show':$parentInfo.dialog_InvoiceDetail.printOn}"
                     style=";position: relative;">

                    <div style="position: relative" class="invoice-body">
                        <div>
                            <div class='invoiceNumber'>
                                合同编号：{{$store.state.modal.data.invoice.prefix}}-{{$store.state.modal.data.invoice.id}}
                            </div>
                            <div >
                                <h3 class="title">定金协议书</h3>

                            </div>
                            <div >
                                <p><b>甲方（教育方）：上海墨帝教育科技服务有限公司</b></p>
                                <p><b>甲方地址：上海市青浦区盈港路499弄3幢 邮政编码：201700</b></p>
                                <p><b>甲方联系方式：021-59830737 公众号：墨帝教育</b></p>
                                <p><b>乙方（受教育方）：学生姓名：
                                    <span
                                            style="text-decoration: underline">　　{{$store.state.modal.data.invoice.student_name}}　</span>　　学校：<span
                                            style="text-decoration: underline">　{{$store.state.modal.data.invoice.student_school}}　
                                　</span>　　现新年级：<span style="text-decoration: underline">　{{$store.state.modal.data.invoice.student_grade}}　</span><br>
                                    乙方 监 护 人：<span style="text-decoration: underline">　{{$store.state.modal.data.invoice.parent_name}}　 {{$store.state.modal.data.invoice.parent_identity}}　</span>　<br>
                                    乙方 联系方式：<span
                                            style="text-decoration: underline">　{{$store.state.modal.data.invoice.student_phone}}　</span>　　家长联系方式：<span
                                            style="text-decoration: underline">　{{$store.state.modal.data.invoice.parent_phone}}　</span>　
                                </b></p>
                            </div>
                            <div>
                                <p>甲、乙双方遵循自愿、公平和诚实守信的原则、经协商一致，就乙方向甲方预定课程服务事宜，订立本协议。</p>
                            </div>
                            <div >
                                <p>第一条 乙方预定墨帝教育2021年寒假及春季美术班课程。课程预计时间为2021年1月15日至2021年6月30日（以实际安排为准）。课程价格以支付定金时的2021年寒假及春季美术班课程价格为准。</p>
                            </div>
                            <div >
                                <p> 第二条 乙方同意订立本协议时，支付定金人民币<span
                                        style="text-decoration: underline"> {{$store.state.modal.data.invoice.countPayment}} </span> 元，作为甲、乙方双方当事人订立正式服务协议书的担保，签订服务协议书后，乙方支付的定金转为课程款。同时，若乙方满足美术班连报优惠规则，则可额外享受800元现金优惠用于抵扣课程款。
                                </p>
                            </div>
                            <div >
                                <p>
                                    第三条 甲、乙双方商定，乙方应于2020年11月30日前与甲方签订关于购买2021年寒假及春季美术班课程的《墨帝教育服务协议书》，若乙方未能在上述规定日期前完成签订的，甲方有权保留定金不予退还。
                                </p>
                            </div>
                            <div>
                                <p>
                                    第四条 本协议自定金交付之日起生效。
                                </p>
                            </div>

                            <div style="float: left;width: 60%">
                                <p>甲方：上海墨帝教育科技服务有限公司</p>
                                <p>甲方代表签字：</p>
                            </div>
                            <div style="float: left;">
                                <p>乙方： {{$store.state.modal.data.invoice.student_name}}</p>
                                <p>乙方监护人签字：</p>
                                <p>本协议于在上海签订</p>
                            </div>

                            <div style="clear: both"></div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    import QRCode from 'qrcode'
    export default {
        name: 'Dialog_InvoiceDetail',
        data() {
            return {
                QRCodeMsg:'234',
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            //this.handleInvoiceDetail()
            this.QRCodeMsg='http://server.modijiaoyu.com/invoicePhoto?invoice_id='+this.$store.state.modal.data.invoice.id
        },
        mounted(){
            var msg= document.getElementById('msg')
            // 将获取到的数据（val）画到msg（canvas）上
            QRCode.toCanvas(msg, this.QRCodeMsg, function (error) {
            })
        },
        methods: {
            modelClose() {
                ipc.send('invoiceDetailClose');
            },

        }
    };
</script>
